import { getRegisteredGatewayHosts } from "@degaus/shared/brand-config";

/**
 * Should this host fire Google Ads conversions?
 *
 * The legacy auth-gateway hosts (login.wonda.sh) serve this same SPA until
 * their DNS records are retired, so a page viewed there must not fire a
 * conversion the product host would fire again for the same account —
 * localStorage is origin-scoped, so neither fire suppresses the other.
 *
 * Conversions belong on the product host regardless: `getStoredGclid()` reads
 * the product origin's localStorage, so a gateway-side fire carries no click
 * attribution.
 *
 * Kept in its own module so it can be unit-tested without pulling in the
 * gtag-loading side effects of google-ads.ts.
 */
const GATEWAY_HOSTS: ReadonlySet<string> = new Set(getRegisteredGatewayHosts());

/** Pure host check, exported for tests. */
export function checkIsGatewayHostName(host: string): boolean {
  return GATEWAY_HOSTS.has(host);
}

export function checkIsConversionTrackingHost(): boolean {
  return (
    typeof window === "undefined" ||
    !checkIsGatewayHostName(window.location.host)
  );
}
